import { render, staticRenderFns } from "./client-info-tab.vue?vue&type=template&id=5e07e1ae&scoped=true"
import script from "./client-info-tab.vue?vue&type=script&lang=js"
export * from "./client-info-tab.vue?vue&type=script&lang=js"
import style0 from "./client-info-tab.vue?vue&type=style&index=0&id=5e07e1ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e07e1ae",
  null
  
)

export default component.exports